// @noflow
import { css } from 'styled-components';

export const breakPoints = {
    mobile: '40em', // font-size: 14px
    tablet: '40em', // font-size: 16px
    desktop: '64em', // font-size: 18px
    large: '90em',
    xlarge: '130em'
};

export const media = {
    mobile: (...args) => css`@media (max-width: ${breakPoints.mobile}) {${css(...args)};}`,
    tablet: (...args) => css`@media (min-width: ${breakPoints.tablet}) {${css(...args)};}`,
    desktop: (...args) => css`@media (min-width: ${breakPoints.desktop}) {${css(...args)};}`,
    large: (...args) => css`@media (min-width: ${breakPoints.large}) {${css(...args)};}`,
    xlarge: (...args) => css`@media (min-width: ${breakPoints.xlarge}) {${css(...args)};}`
};



// WEBPACK FOOTER //
// ./src/core/utils/style.js